import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/components/theme-provider";
import * as Switch from "@radix-ui/react-switch";
import { cn } from "@/lib/utils";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <Switch.Root
      checked={theme === 'dark'}
      onCheckedChange={() => setTheme(theme === "light" ? "dark" : "light")}
      className={cn(
        "relative inline-flex h-[32px] w-[64px] shrink-0 cursor-pointer rounded-full transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "bg-white dark:bg-slate-900 border-2 border-slate-200 dark:border-slate-800"
      )}
    >
      <Switch.Thumb className={cn(
        "pointer-events-none block h-[28px] w-[28px] rounded-full shadow-lg ring-0 transition-transform",
        "bg-white dark:bg-slate-950",
        "data-[state=checked]:translate-x-[32px] data-[state=unchecked]:translate-x-0",
        "flex items-center justify-center"
      )}>
        {theme === 'dark' ? (
          <Moon className="h-4 w-4 text-sky-400" />
        ) : (
          <Sun className="h-4 w-4 text-amber-400" />
        )}
      </Switch.Thumb>
    </Switch.Root>
  );
} 